import React from 'react';
import { FormField } from './formTypes';
import * as inputStyles from './form.module.css';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';

export const styles =
    makeStyles((theme) => ({
        input: {
            color: "#000",
            backgroundColor: "#fff",
        },
        root: {
            "& .Mui-error": {
                color: "#df2e27",
            },
        },
        singleLineContainer: {
            display: "flex",
        },
        multilineContainer: {

        },
        singleLine: {
            whiteSpace: "nowrap",
            marginRight: "10px",
            paddingTop: "34px",
        },
        multiline: {

        }
    }));

interface Props {
    value: any;
    field: FormField;
    valid: boolean;
    onChanged(field: FormField, newValue: any): void;
    disabled: boolean;
};

const Field = ({ field, value, valid, onChanged, disabled }: Props) => {
    const classes = styles();
    const update = e => {
        if (onChanged && typeof (onChanged) === "function")
            onChanged(field, e.target.value)
    }

    const error = () => {
        if (value)
            return valid ? false : true
        else
            return false
    }

    const errClass = (error() ? inputStyles.validationFail : inputStyles.validationPass)

    return (
        <label className={field.multiline ? classes.multilineContainer : classes.singleLineContainer }>
            {field.label && <div className={field.multiline ? classes.multiline : classes.singleLine}>{field.label}</div>}
            <TextField
                disabled={disabled}
                variant="outlined"
                margin="normal"
                required={field.mandatory}
                fullWidth
                id={field.fieldId}
                key={field.fieldId}
                value={value}
                label={field.name}
                name={field.name}
                autoComplete={field.name}
                onChange={update}
                className={`${inputStyles.formField} ${errClass} ${classes.root}`}
                placeholder={field.name}
                multiline={field.multiline}
                rows={4}
                error={error()}
                InputProps={{className: classes.input}}
            />
        </label>
    )
}

export default Field;